import styled, { ITheme } from '../../../theme'
import InputSquare from './InputSquare'

const Selected = styled.div<{ size?: number }>`
  display: block;
  position: relative;
  background-color: ${({ theme }: ITheme) => theme.colors.palette.greyTwo};
  border: 5px solid ${({ theme }: ITheme) => theme.colors.palette.greyTwo};
  border-radius: 3px;
  height: ${({ size }) => (size ? 18 * size : 18)}px;
  width: ${({ size }) => (size ? 18 * size : 18)}px;
  z-index: 5;
  transition: border 0.25s linear, background-color 0.25s linear;

  &:before {
    display: block;
    position: absolute;
    content: '✓';
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    color: ${({ theme }: ITheme) => theme.colors.palette.greyTwo};
  }

  ${InputSquare}:not(:checked) ~ &:before {
    content: '';
  }

  ${InputSquare}:checked ~ & {
    border: 5px solid ${({ theme }: ITheme) => theme.colors.palette.emerald};
    background-color: ${({ theme }: ITheme) => theme.colors.palette.emerald};
  }

  ${InputSquare}:checked:disabled ~ & {
    border: 5px solid ${({ theme }: ITheme) => theme.colors.palette.greyTwo};
    background-color: ${({ theme }: ITheme) => theme.colors.palette.greyTwo};
    cursor: not-allowed;
  }

  ${InputSquare}:checked:disabled ~ &:before {
    color: ${({ theme }: ITheme) => theme.colors.palette.white};
  }

  ${InputSquare}:disabled ~ & {
    border: 5px solid ${({ theme }: ITheme) => theme.colors.palette.greyTwo};
    background-color: ${({ theme }: ITheme) => theme.colors.palette.greyTwo};
    cursor: not-allowed;
  }

  ${InputSquare}:disabled ~ &:before {
    color: ${({ theme }: ITheme) => theme.colors.palette.white};
  }

  ${InputSquare}:checked ~ &:before {
    color: white;
  }
`

export default Selected
